import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'

import { Context } from 'components/core/Acquiring/AcquiringCharges/components/AcquiringChargesContext'
import { Arrow, Pagination, PaginationContainer } from 'components/core/Acquiring/styles'
import { startGetCardAcquiringCharges } from 'redux/acquiring/acquiring-actions'

const step = 10

const AcquiringChargesStepper = () => {
    const dispatch = useDispatch()
    const [pageSize, setPageSize] = useState(0)
    const [chargesInputs, setChargesInputs] = useState<ChargesInputs>({ from: null, to: null, status: null, skip: null, take: null })

    const { charges, loader } = useContext(Context)

    useEffect(() => {
        dispatch(startGetCardAcquiringCharges({ ...chargesInputs, skip: pageSize, take: step }))
    }, [pageSize])

    const handleStepper = (way: boolean) => {
        setChargesInputs({ ...chargesInputs, skip: pageSize, take: step })
        setPageSize(prevSize => (way ? prevSize + step : prevSize - step))
    }

    if (!!loader?.GET_CARD_ACQUIRING_CHARGES || (pageSize <= 0 && !charges?.hasMore)) {
        return <></>
    }

    return (
        <PaginationContainer>
            <Pagination>
                <Arrow onClick={() => handleStepper(false)} hasPreviousPage={pageSize <= 0}>
                    <ArrowBackIos />
                </Arrow>
                <div>{(pageSize + step) / step}</div>
                <Arrow onClick={() => handleStepper(true)} hasNextPage={!charges?.hasMore}>
                    <ArrowForwardIos />
                </Arrow>
            </Pagination>
        </PaginationContainer>
    )
}

export default AcquiringChargesStepper
